import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from 'src/services/core/base/base.service';

const routes = {
  notifications: 'api/v1/restaurants/notifications',
  markNotification: 'api/v1/restaurants/mark-notification',
};

@Injectable({
  providedIn: 'root',
})
export class NotifsService extends BaseService<any> {
  constructor(public http: HttpClient) {
    super(http);
  }

  getAllNotifications(): Observable<any> {
    return this.sendGet(this.baseUrl(routes.notifications));
  }

  markAllNotificationsAsRead(): Observable<any> {
    return this.sendPut(this.baseUrl(routes.markNotification), {});
  }

  markNotificationAsRead(notificationId: number): Observable<any> {
    return this.sendPut(
      `${this.baseUrl(routes.markNotification)}?id=${notificationId}`,
      {}
    );
  }
}
